import { render, staticRenderFns } from "./safeWorkPermit.vue?vue&type=template&id=96b7cf8a"
import script from "./safeWorkPermit.vue?vue&type=script&lang=js"
export * from "./safeWorkPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96b7cf8a')) {
      api.createRecord('96b7cf8a', component.options)
    } else {
      api.reload('96b7cf8a', component.options)
    }
    module.hot.accept("./safeWorkPermit.vue?vue&type=template&id=96b7cf8a", function () {
      api.rerender('96b7cf8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/safeWorkPermit.vue"
export default component.exports